import React from "react";
import { TIER_VALUES as TIERS } from "./constants";

// Progress / result card for "Re-score rules only".
export default function RulesRescoreResult({ job, styles }) {
  const done = job.status === "done";
  const before = job.tiers_before || {};
  const after = job.tiers_after || {};
  const llm = job.llm || {};
  return (
    <div style={styles.card} data-testid="rules-rescore-card">
      <strong>Rules-only re-score</strong> <code>{(job.detector_version || "").split("+")[0]}</code>: <strong>{job.status}</strong>
      {" "}· {job.processed ?? 0}/{job.total ?? 0} items
      {job.missing_content > 0 && <> · <span style={{ color: "var(--hs-danger)" }}>{job.missing_content} skipped: content missing</span></>}
      {done && (
        <div style={{ marginTop: 8, fontSize: 12 }}>
          <table style={styles.tbl} data-testid="rules-rescore-tiers">
            <thead><tr><th style={styles.th}>Tier</th><th style={styles.th}>Before</th><th style={styles.th}>After</th><th style={styles.th}>Change</th></tr></thead>
            <tbody>{TIERS.map((t) => {
              const d = (after[t] || 0) - (before[t] || 0);
              return (
                <tr key={t}><td style={styles.td}>{t}</td><td style={styles.td}>{before[t] || 0}</td><td style={styles.td}>{after[t] || 0}</td>
                  <td style={{ ...styles.td, color: d < 0 ? "var(--hs-safe)" : d > 0 ? "var(--hs-warning)" : "var(--hs-text-muted)" }}>{d > 0 ? `+${d}` : d}</td></tr>);
            })}</tbody>
          </table>
          <div style={{ marginTop: 6 }} data-testid="rules-rescore-summary">
            <strong>{job.heuristic_cleared ?? 0}</strong> heuristic flag(s) cleared · <strong>{job.newly_flagged ?? 0}</strong> newly flagged
            {" "}· {job.unchanged ?? 0} unchanged (already scored by this rules version)
            {" "}· model calls: {llm.ok ?? 0} ok, {llm.error ?? 0} error, {llm.cap ?? 0} stopped by cap (only for items that newly crossed the gate)
          </div>
          {Object.keys(job.transitions || {}).length > 0 && (
            <div style={{ marginTop: 4, color: "var(--hs-text-muted)" }}>
              Moves: {Object.entries(job.transitions).map(([k, v]) => `${k.replace("->", " → ")}: ${v}`).join(" · ")}
            </div>)}
        </div>)}
    </div>
  );
}
